import { useEffect, useState } from "react";
import { IValoresProdutos } from '../components/Interfaces/IValoresProdutos';

export const useProdutos = () => {
    const [produtos, setProdutos] = useState<IValoresProdutos[]>([]);

    let URL = process.env.REACT_APP_API_HOST || 'environment not defined';

    useEffect(() => {
        fetch(URL+'cliente/controller/controllerProdutoAberturaChamado.asp')
            .then((result) => result.json())
            .then((data) => setProdutos(data));
    }, []);

    return{
        produtos,
    };
};